<template>
  <div>
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div v-if="!showForm">
        <spinner />
      </div>
      <div v-else>
        <div class="row container-details">
          <div class="col-xs-12">
            <div class="form-header">
              <active-user-icon title="Usuário" />
              <h5 v-if="formType == 'edit'" class="User-name">
                Editar usuário {{ oldLogin }}
              </h5>
              <h5 v-else class="User-name">Adicionar usuário</h5>
            </div>
            <b-form novalidate class="col-xs-12">
              <b-form-text id="userNameInputHelp">Nome *</b-form-text>
              <b-form-input
                :state="nameState"
                v-model="form.NAME"
                placeholder="Nome"
                aria-describedby="userNameInputHelp userNameInputFeedback"
                maxlength="45"
                id="userNameInput"
                size="sm"
              />
              <b-form-invalid-feedback
                v-if="!nameState"
                id="userNameInputFeedback"
              >
                Campo inválido
              </b-form-invalid-feedback>
              <b-form-text id="userLoginInputHelp"
                >Login * (mín: 4, máx: 10)</b-form-text
              >
              <b-form-input
                :state="loginState && notRepeatedLogin"
                v-model="form.LOGIN"
                placeholder="Login"
                aria-describedby="userLoginInputHelp userLoginInputFeedback"
                maxlength="10"
                id="userLoginInput"
                size="sm"
              >
              </b-form-input>
              <b-form-invalid-feedback
                v-if="!loginState"
                id="userLoginInputFeedback"
              >
                Campo inválido
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-if="!notRepeatedLogin">
                Esse login já está em uso
              </b-form-invalid-feedback>
              <div v-if="formType == 'add'">
                <b-form-text id="pwdInputHelp" size="sm"
                  >Senha * (mín: 6, máx: 20)
                </b-form-text>
                <b-input-group size="sm">
                  <b-form-input
                    :state="addPwdState"
                    v-model.trim="form.PSW"
                    placeholder="Senha"
                    aria-describedby="pwdInputHelp pwdInputFeedback"
                    :type="showPwd ? 'text' : 'password'"
                    maxlengt="20"
                    size="sm"
                  />
                  <b-input-group-append>
                    <!-- size="sm" -->
                    <b-button
                      class="changePwd"
                      :variant="addPwdState ? 'success' : 'danger'"
                      @click="showPwd = !showPwd"
                      size="sm"
                    >
                      <eye-icon v-if="!showPwd" title="" />
                      <eye-off-icon v-else title="" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-form-invalid-feedback
                  v-if="!addPwdState"
                  id="pwdInputFeedback"
                >
                  Campo inválido
                </b-form-invalid-feedback>
              </div>
              <div v-else class="change-password">
                <b-link @click="openChangePwd">Alterar senha</b-link>
              </div>
              <b-form-text id="userEmailInputHelp">E-mail </b-form-text>
              <b-form-input
                v-model="form.EMAIL"
                placeholder="E-mail"
                aria-describedby="userEmailInputHelp"
                :state="true"
                maxlength="100"
                id="userEmailInput"
                size="sm"
              >
              </b-form-input>
              <div v-if="isAdmin">
                <b-form-text id="userRoleSelectHelp">Cargo </b-form-text>
                <!-- state="valid" -->
                <b-form-select
                  v-model="form.PERMISSION"
                  :options="permissions"
                  text-field="name"
                  value-field="value"
                  aria-describedby="userRoleSelectHelp"
                  id="userRoleSelect"
                  size="sm"
                >
                </b-form-select>
                <b-form-text
                  id="userGroupSelectHelp"
                  v-if="form.PERMISSION == 2"
                  >Grupo
                </b-form-text>
                <!-- state="valid" -->
                <searchable-select
                  v-model="form.FK_GROUP"
                  v-if="form.PERMISSION === 2"
                  :options="groups"
                  text-field="NAME"
                  value-field="ID"
                  placeholder="Nenhum"
                />
              </div>
            </b-form>
          </div>
        </div>
        <!--  -->
        <b-modal
          v-if="formType == 'edit'"
          ref="changePWD"
          centered
          hide-backdrop
          size="sm"
          ok-title="Mudar senha"
          @ok="submitNewPWD"
          ok-variant="3v3"
          cancel-title="Cancelar"
          hide-header
        >
          <h5>Trocar senha para {{ itemToEdit.LOGIN }}</h5>
          <b-form novalidate>
            <b-form-text id="pwdInputHelp" size="sm"
              >Senha * (mín: 6, máx: 20)
            </b-form-text>
            <b-input-group size="sm">
              <!-- :state="editPwdState" -->
              <b-form-input
                v-model.trim="pswForm.PSW"
                placeholder="Senha"
                aria-describedby="pwdInputHelp pwdInputFeedback"
                :type="showPwd ? 'text' : 'password'"
                maxlengt="20"
              />
              <b-input-group-append>
                <!-- size="sm" -->
                <b-button
                  size="sm"
                  :variant="editPwdState ? 'success' : 'danger'"
                  @click="showPwd = !showPwd"
                >
                  <eye-icon v-if="!showPwd" title="" />
                  <eye-off-icon v-else title="" />
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form>
        </b-modal>

        <b-modal
          ref="formError"
          no-close-on-backdrop
          centered
          hide-footer
          body-bg-variant="light"
          title="Atenção!"
        >
          <div class="modal-form row pb-3">
            <div class="col-xs-12 center-xs">
              <alert-icon title="" style="font-size: 3em; color: #ffc107" />
            </div>
            <div class="col-xs-12 error-title">
              Não é possível seguir para edição de níveis porque:
            </div>
            <div class="col-xs-12 error-description">
              <ul>
                <li v-for="err in errors" :key="err">{{ err }}</li>
              </ul>
            </div>
          </div>
          <b-btn
            v-if="$refs.formError"
            block
            variant="secondary"
            size="sm"
            @click="$refs.formError.hide"
            >Irei corrigir</b-btn
          >
        </b-modal>
        <footer id="footer" class="pb-2 d-flex">
          <b-btn
            size="sm"
            variant="outline-secondary"
            @click="$emit('close-form')"
            class="ml-2 mr-1 w-100"
          >
            Cancelar
          </b-btn>
          <b-btn
            variant="3v3"
            @click="checkForm"
            size="sm"
            class="ml-1 mr-2 w-100"
          >
            Salvar
          </b-btn>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import {
  testName,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";
import { schedules } from "@/api";
import { users, listEquipments } from "@/api";
import crypto from "crypto-browserify";
import store from "@/store";
import SearchableSelect from "@/pages/components/shared/SearchableSelect.vue";
export default {
  name: "user-form",
  components: {
    SearchableSelect,
  },
  props: {
    // showForm: Boolean,
    formType: String,
    // oldLogin: String,
    alreadyUsedLogins: Array,
    itemToEdit: [Number, Object],
    // isAdmin: Boolean,
    // groups: Array,
  },
  data() {
    return {
      showForm: false,
      errors: [],
      groups: [],
      permissions: [
        {
          name: "Usuário",
          value: 2,
        },
        {
          name: "Administrador",
          value: 1,
        },
      ],
      showPwd: false,
      form: {
        ID: null,
        NAME: "",
        LOGIN: "",
        EMAIL: "",
        PSW: "",
        PERMISSION: 2, //default
        FK_GROUP: null,
      },
      pswForm: {
        ID: null,
        LOGIN: "",
        PSW: "",
      },
    };
  },
  async created() {
    await this.loadGroups();
    if (this.formType == "add") {
      this.resetForm();
    } else {
      this.form.ID = this.itemToEdit.ID;
      this.form.NAME = this.itemToEdit.NAME;
      this.form.LOGIN = this.itemToEdit.LOGIN;
      this.form.EMAIL = this.itemToEdit.EMAIL;
      this.form.PERMISSION = this.itemToEdit.PERMISSION;
      this.form.FK_GROUP = this.itemToEdit.FK_GROUP;
    }
    this.showForm = true;
  },
  watch: {
    // showForm(newVal, oldVal) {
    //   if (!oldVal && newVal) {
    //     this.step = 1;
    //     if (this.formType == "add") this.resetForm();
    //     else {
    //       this.form.ID = this.itemToEdit.ID;
    //       this.form.NAME = this.itemToEdit.NAME;
    //       this.form.LOGIN = this.itemToEdit.LOGIN;
    //       this.form.EMAIL = this.itemToEdit.EMAIL;
    //       this.form.PERMISSION = this.itemToEdit.PERMISSION;
    //       this.form.FK_GROUP = this.itemToEdit.FK_GROUP;
    //     }
    //   }
    // },
  },
  computed: {
    activeUser() {
      return {
        ID: store.state.userData.ID,
        PERMISSION: store.state.userData.PERMISSION,
      };
    },
    oldLogin() {
      return this.itemToEdit && this.itemToEdit.LOGIN;
    },
    isAdmin() {
      return store.getters.isAdmin;
    },
    nameState() {
      return !!this.form.NAME;
    },
    notRepeatedLogin() {
      return notRepeatedName(
        this.alreadyUsedLogins,
        this.form.LOGIN,
        this.formType,
        this.oldLogin
      );
    },
    loginState() {
      return (
        testName(this.form.LOGIN) &&
        this.form.LOGIN.length > 3 &&
        this.form.LOGIN.length < 11
      );
    },
    addPwdState() {
      return (
        this.form.PSW != "" &&
        this.form.PSW.length > 5 &&
        this.form.PSW.length < 21
      );
    },
    editPwdState() {
      return (
        this.pswForm.PSW != "" &&
        this.pswForm.PSW.length > 5 &&
        this.pswForm.PSW.length < 21
      );
    },
  },
  methods: {
    async loadGroups() {
      this.groups = await users.groups.list();
    },
    openChangePwd() {
      this.pswForm.PSW = "";
      this.pswForm.LOGIN = this.itemToEdit.LOGIN;
      this.pswForm.ID = this.itemToEdit.ID;
      this.showPwd = false;
      this.$refs.changePWD.show();
    },

    submitNewPWD(e) {
      if (this.editPwdState) {
        users
          .changePwd({
            ID: this.pswForm.ID,
            LOGIN: this.pswForm.LOGIN,
            PSW: crypto
              .createHash("md5")
              .update(this.pswForm.PSW)
              .digest("hex"),
          })

          .then((ret) => {
            alert(ret.log, ret.alert);
          })
          .catch((err) => {
            alert("Ocorreu um erro na alteração da senha. Tente novamente.");
          });
      } else e.preventDefault();
    },
    // submitNewPWD(data) {
    //   users
    //     .changePwd({
    //       ID: data.ID,
    //       LOGIN: data.LOGIN,
    //       PSW: crypto.createHash("md5").update(data.PSW).digest("hex"),
    //     })
    //     .then((ret) => {
    //       alert(ret.log, ret.alert);
    //     })
    //     .catch((err) => {
    //       alert("Ocorreu um erro na alteração da senha. Tente novamente.");
    //     });
    // },
    checkForm() {
      this.errors = [];
      let states = [
        this.nameState,
        this.loginState,
        this.notRepeatedLogin,
        this.formType == "add" ? this.addPwdState : true,
      ];
      let erros = [
        "Nome é obrigatório.",
        "Login é obrigatório. Permitidos apenas letras, números, pontos, hífens e underlines. Espaços NÃO são permitidos. 4 a 10 caracteres.",
        "Login escolhido já está em uso. Verifique.",
        "Senha é obrigatória. 6 a 10 caracteres.",
      ];
      states.map((e, i) => {
        if (!e) {
          this.errors.push(erros[i]);
        }
      });
      if (this.errors.length) this.$refs.formError.show();
      else {
        this.submit(this.form);
      }
    },
    submit(data) {
      if (this.formType == "add")
        data.PSW = crypto.createHash("md5").update(data.PSW).digest("hex");
      users[this.formType](data)
        .then((ret) => {
          alert(ret.log, ret.alert);
          if (ret.alert == "s") {
            this.loadUsers();
            if (this.activeUser.ID == data.ID) {
              //autoconfig
              user.setLogin(data.LOGIN);
              user.setPermission(data.PERMISSION);
              this.$emit("change-active-user");
            }
          }
          this.resetForm();
        })
        .catch((err) => {
          console.log(err);
        });

      this.$emit("get-data-again");
      this.$emit("close-form");
    },
    loadUsers() {
      users
        .list()
        .then((ret) => {
          this.list = ret;
          this.fullList = this.list.map((e) => e);
        })
        .catch((err) => {
          alert("Erro ao carregar usuários.", "w");
          console.log(err);
        })
        .then((_) => (this.loading = false))
        .then((_) => {
          if (
            !this.list.length &&
            this.showErrorNotSearch === false &&
            !this.loading
          ) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        });
    },
    resetForm() {
      this.form = {
        ID: null,
        NAME: "",
        LOGIN: "",
        EMAIL: "",
        PSW: "",
        PERMISSION: 2,
        FK_GROUP: null,
      };
      this.showPwd = false;
    },
  },
};
</script>
<style scoped>
button.changePwd {
  height: calc(1.5em + 0.5rem + 2px);
}
.form-header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* padding: 0 0rem 0.5rem 0rem; */
  border-bottom: 1px solid #eee;
  margin-bottom: 6px;
}
.form-header.material-design-icon {
  margin-bottom: 0.3em;
  margin-right: 0.3em;
  padding-bottom: 1em;
}
.material-design-icon {
  font-size: 1.3em;
}
.change-password {
  width: 100%;
  height: 38px;
  margin-top: 10px;
  margin-bottom: 5px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.change-password a:hover {
  background: rgb(233, 233, 233);
}
.change-password a {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border: 1px solid black;
  border-radius: 4px;
  text-align: center;
  background: rgb(245, 245, 245);
  border: 1px solid #979797;
  transition: all 0.4s ease;
  padding: 4px;
  color: #8a8a8a;
  font-weight: 500;
  font-size: 0.9em;
}
#footer {
  display: flex;
}
.User-name {
  font-family: "SourceSansPro_Semibold", Arial, Helvetica, sans-serif;
  text-align: center;
}
@media screen and (max-width: 768px) {
  .container-details {
    padding-bottom: 3em;
    padding-left: 0.6em;
    padding-right: 0;
    margin-right: 0;
  }
}
</style>
